export enum WaterfallTenderStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED_WITHOUT_ACCEPTED_RATE_QUOTE = 'COMPLETED_WITHOUT_ACCEPTED_RATE_QUOTE',
  COMPLETED_SUCCESSFULLY = 'COMPLETED_SUCCESSFULLY',
  CANCELED = 'CANCELED',
}
